export const ApiStatus = Object.freeze({
  loading: 'loading',
  failed: 'failed',
  success: 'success',
  idle: 'idle'
});

export const TipResult = Object.freeze({
  pending: 'pending',
  success: 'success',
  failure: 'failure',
  push: 'push'
});

export function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
